import React from 'react';
import { Card, Collapse } from 'reactstrap';
import { formatTimestamp } from '../../../helpers/formatter';
import PickupDetailsReview from './DirectComponents/PickupDetailsReview';
import DropoffDetailsReview from './DirectComponents/DropoffDetailsReview';
import WaypointDetailsReview from './DirectComponents/WaypointDetailsReview';
import WaypointItemsDescription from './DirectComponents/WaypointItemsDescription';
import ShipmentDescription from './DirectComponents/ShipmentDescription';
import ConfirmButtons from './DirectComponents/ConfirmButtons';
import BillingInfoReview from './DirectComponents/BillingInfoReview';

const RoutedConfirmPage = ({
  showForm3,
  pickupInfo,
  pickupInstruction,
  merchantOrderID,
  vehicleType,
  numPeople,
  scheduledFor,
  isExpedited,
  isScheduled,
  handleBack,
  price,
  handleConfirmRouted,
  setIsSaved,
  setOrderStatus,
  setShipmentStatus,
  dropoffInfo,
  dropoffInstruction,
  waypointInfo,
  waypointPickupInstruction,
  waypointDropoffInstruction,
  pickupItems,
  isWaypointPickup,
  waypointPickupItems,
  priceRangeLow,
  priceRangeHigh,
  quoteLineItems,
  isInvoice,
  billingInfo,
  editingActiveShipmentId,
  originalPrice
}) => {
  const isActiveEdit = Boolean(editingActiveShipmentId);
  const newPriceNum = Number(price);
  const originalPriceNum = Number(originalPrice);
  const hasPriceDelta = isActiveEdit && Number.isFinite(newPriceNum) && Number.isFinite(originalPriceNum);
  const priceDelta = hasPriceDelta ? newPriceNum - originalPriceNum : 0;
  return (
    <Collapse isOpen={showForm3} style={{ backgroundColor: '#27293d' }}>
      <Card style={{ backgroundColor: '#27293d', color: '#fff' }} className="card-form">
        <form className="dropship-container" autoComplete="off" style={{ padding: `100px` }}>
          <div>
            <div style={{ marginBottom: 15, marginTop: 25, fontSize: 15, color: '#f7941d' }}>
              Review your order
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
            {isInvoice && (
              <div>
                <BillingInfoReview billingInfo={billingInfo} />
                <hr style={{ backgroundColor: '#344675' }} />
              </div>
            )}
            <div>
              <PickupDetailsReview pickupInfo={pickupInfo} pickupInstruction={pickupInstruction} />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>

            <div>
              <WaypointDetailsReview waypointInfo={waypointInfo} waypointPickupInstruction={waypointPickupInstruction} waypointDropoffInstruction={waypointDropoffInstruction} />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>

            <div>
              <DropoffDetailsReview dropoffInfo={dropoffInfo} dropoffInstruction={dropoffInstruction} />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
            <div>
              <div style={{ color: '#fff', fontStyle: 'bold' }}>Shipment Description</div>
              <WaypointItemsDescription pickupItems={pickupItems} isWaypointPickup={isWaypointPickup} waypointPickupItems={waypointPickupItems} />
              <ShipmentDescription
                merchantOrderID={merchantOrderID}
                vehicleType={vehicleType}
                numPeople={numPeople}
                scheduledFor={scheduledFor}
                formatTimestamp={formatTimestamp}
              />
              <hr style={{ backgroundColor: '#344675' }} />
            </div>
          </div>
          {hasPriceDelta && (
            <div style={{ marginBottom: 20, padding: 16, borderRadius: 8, backgroundColor: '#1e1e2f', border: '1px solid #344675' }}>
              <div style={{ color: '#f7941d', fontWeight: 'bold', marginBottom: 8 }}>Price change</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cdcaca', marginBottom: 4 }}>
                <span>Original price</span>
                <span>${originalPriceNum.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#fff', marginBottom: 4 }}>
                <span>New price</span>
                <span>${newPriceNum.toFixed(2)}</span>
              </div>
              <hr style={{ backgroundColor: '#344675', margin: '8px 0' }} />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: 'bold',
                  color: priceDelta > 0 ? '#ff6b6b' : priceDelta < 0 ? '#2dce89' : '#fff',
                }}
              >
                <span>
                  {priceDelta > 0 ? 'Additional charge' : priceDelta < 0 ? 'Refund' : 'No change'}
                </span>
                <span>
                  {priceDelta > 0 ? '+' : priceDelta < 0 ? '-' : ''}${Math.abs(priceDelta).toFixed(2)}
                </span>
              </div>
            </div>
          )}
          <ConfirmButtons
            isExpedited={isExpedited}
            price={price}
            isScheduled={isScheduled}
            handleBack={handleBack}
            handleConfirm={handleConfirmRouted}
            setIsSaved={setIsSaved}
            setOrderStatus={setOrderStatus}
            setShipmentStatus={setShipmentStatus}
            vehicleType={vehicleType}
            priceRangeLow={priceRangeLow}
            priceRangeHigh={priceRangeHigh}
            quoteLineItems={quoteLineItems}
          />
        </form>
      </Card>
    </Collapse>
  );
};

export default RoutedConfirmPage;
